//@ts-nocheck
import { Dialog } from "@mui/material";
import MarkLogo from "../../assets/images/MarkLogo.png";
import OTPInput from "../Otp/Otp";
import {
  LogoImg,
  ModalMessage,
  ModalTitle
} from "./styles/OTPValidationModalStyles";

const OTPValidationModal = ({
  onOTPChange,
  value,
  modalState,
}: IOTPValidationModalProps) => {
  return (
    <Dialog open={modalState}>
      <div
        style={{
          justifyContent: "center",
          padding: "32px",
          textAlign: "center",
        }}
      >
        <LogoImg style={{ maxWidth: "300px" }} src={MarkLogo} />
        <ModalTitle>Validación OTP</ModalTitle>
        <ModalMessage>Introduzca el Código del patrocinador</ModalMessage>
        <div>
        <OTPInput length={4} value={value} onChange={onOTPChange} />

        </div>
      </div>
    </Dialog>
  );
};

export type IOTPValidationModalProps = {
  modalState: boolean;
  onOTPChange?: (code: string) => void;
  value?: string;
};
export default OTPValidationModal;
